import styled from 'styled-components';

import { Types } from './index';
import { IChangeLog } from '../../globals/interfaces';
import { formatDatetime } from '../../utils';
import _ from 'lodash';

interface Props {
    item: IChangeLog;
    type: Types;
    history: History;
}

export default function Item({ item, type, history }: Props) {
    const className =
        type === 'ADDED'
            ? 'fad fa-plus'
            : type === 'CHANGED'
            ? 'fad fa-pen'
            : 'fad fa-wrench';


    return (
        <div>
            <h6>
                <i className={`${className} pr-2`} />
                {item.title}
            </h6>
            <ul>
                <ItemDetail detail={item.detail} />
                {/* @ts-ignore */}
                {item.url && <GotoLink onClick={() => history.push(item.url)}>{item.url} <i className="fa-solid fa-arrow-right-to-bracket pl-1"></i></GotoLink>}
            </ul>
        </div>
    );
}

const ItemDetail = ({
    detail
}: {
    detail: string | null
}) => {
    if (!detail) return null;
    
    const renderDetail = detail.replaceAll('img', 'img style="max-width: 1000px; height: auto;"');

    return <li dangerouslySetInnerHTML={{__html: renderDetail}}></li>;
}   

const GotoLink = styled.li`
    color: blue;
    &:hover {
        cursor: pointer;
    }
`;